import type { RestaurantAccountManager } from 'apis/restaurants/types';
import { Text, VStack } from 'design-system';

export interface IAccountManagerCell {
  accountManager: RestaurantAccountManager | null;
}

export const AccountManagerCell = ({ accountManager }: IAccountManagerCell) => {
  if (!accountManager) {
    return <Text color='gray.400'>Unassigned</Text>;
  }

  return (
    <VStack align='start' spacing='0'>
      <Text fontWeight='semibold' color='gray.600'>
        {accountManager.name}
      </Text>
      {accountManager.email && (
        <Text fontSize='sm' color='gray.500'>
          {accountManager.email}
        </Text>
      )}
    </VStack>
  );
};
